import type { SVGProps } from "react";
export interface CupWaterIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CupWaterIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CupWaterIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.641 16.132a1.375 1.375 0 1 1-1.509 1.509l-.007-.141.007-.14a1.376 1.376 0 0 1 1.369-1.235zm-3-3a1.375 1.375 0 1 1-1.509 1.509l-.007-.141.007-.14a1.376 1.376 0 0 1 1.369-1.236zm-1.64-4.257c1.486 0 2.456.29 3.319.546.819.244 1.533.454 2.68.454l.605-.019a10 10 0 0 0 1.462-.205 8 8 0 0 0 .749-.205h.001a1.125 1.125 0 0 1 .788 2.108L18.21 10.5l.394 1.055h-.002l-.008.005-.02.006-.062.021-.213.07c-.18.054-.433.123-.748.193a12 12 0 0 1-2.55.277c-1.487 0-2.458-.29-3.321-.547-.717-.213-1.352-.402-2.27-.445l-.41-.01a9.7 9.7 0 0 0-2.066.224 8 8 0 0 0-.721.195l-.03.01-.002.002v-.002a1.124 1.124 0 0 1-.786-2.108h.002l.003-.001.007-.003.02-.007.06-.02q.079-.028.213-.07c.18-.054.435-.124.75-.193.63-.139 1.515-.277 2.55-.277Z"
      />
      <path
        fill={color}
        d="M17.999.875c1.183 0 2.122.961 2.125 2.115l-.011.233-1.711 16.21a4.124 4.124 0 0 1-4.102 3.692H9.7a4.125 4.125 0 0 1-4.103-3.692l-1.71-16.21A2.126 2.126 0 0 1 6.003.875H18ZM7.836 19.197c.1.954.905 1.678 1.864 1.678h4.6c.96 0 1.764-.724 1.865-1.678L17.86 3.125H6.14z"
      />
    </svg>
  );
}
